import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import api from "../lib/api";
import { Calendar } from "lucide-react";

export default function NewsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news", { params: { active_only: true } }).then((r) => setItems(r.data));
  }, []);

  return (
    <>
      <PageHero path="news.hero" kicker="News & Events" title="Latest updates from Kiki Centre" subtitle="Press features, milestones, events and what's new in our institute." />
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((n, i) => (
            <article
              key={n.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 tilt-card animate-fade-up"
              style={{ animationDelay: `${i * 0.07}s` }}
            >
              <div className="relative h-56 overflow-hidden group">
                <img src={n.image_url} alt={n.title} className="absolute inset-0 w-full h-full object-cover zoom-img" />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-3 py-1 rounded-full bg-yellow-400 text-[#0B2A6B] text-xs font-bold">
                  <Calendar className="h-3 w-3" />
                  {new Date(n.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                </span>
              </div>
              <div className="p-6">
                <h2 className="font-bold text-[#0B2A6B] text-lg mb-2">{n.title}</h2>
                <p className="text-sm text-slate-600 mb-3 line-clamp-3">{n.excerpt}</p>
                <details className="text-sm">
                  <summary className="cursor-pointer text-yellow-600 font-semibold">Read more</summary>
                  <p className="mt-3 text-slate-700 leading-relaxed">{n.content}</p>
                </details>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
